import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const useEntitiesByRefs = (entityRefs: string[], fields?: string[]) => {
  const catalogApi = useApi(catalogApiRef);

  return useQuery(['entities-by-refs', entityRefs, fields], async () => {
    return catalogApi.getEntitiesByRefs({ entityRefs, fields });
  });
};
